







import {defineComponent} from '@vue/composition-api'

export default defineComponent({
    name: "ListAtom",
    props: {
        title: {
            type: String,
            required: false,
            default: ""
        }
    },
    setup: (props) => {
        return {props}
    }
})
